// © 2015-2021 WDNA - All Rights Reserved

/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable jsx-a11y/control-has-associated-label */

import * as React from 'react';

import Select2, { DataSelect2, EventSelect2 } from 'wdna-select2';
import ContainerModal from 'wdna-components/lib/modals/generics/ContainerModal';

interface Props {
  formValues: any;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onChangeTwo: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCloseModal: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onInfo: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onReset: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onChangeMultiple: (e: EventSelect2) => void;
  fileName: string;
  fileId: string;
  download: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onHandleUploadFile: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onHandleDeletedFile: (e: React.MouseEvent<HTMLButtonElement>) => void;
  showFreeboard: (e: React.MouseEvent<HTMLButtonElement>) => void;
  genApiKey: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Function to create a React Component component
 *
 * @param props component properties
 * @returns react node component
 */
function Form(props: Props): JSX.Element {
  const { companiesArray, typeClientArray, accessListArray } = props.formValues;
  const { data, modalShow, loading } = props.formValues;
  const { fileName, fileId } = props;

  const isNew: boolean = (data.id === undefined || isNaN(data.id));

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Name</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.name || ''}
            name="name"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-6">
          <label className="label">
            <b>Code</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.code || ''}
            name="code"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Company</b> &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
          </label>
          <Select2
            name="company.id"
            data={companiesArray.map((group: any): DataSelect2 => {
              return { text: group.name, id: group.id };
            })}
            value={(data.company && data.company.id) || ''}
            options={{
              placeholder: '(empty)',
            }}
            onChange={props.onChange}
            style={{ width: '80%' }}
          />
        </div>
        <div className="col-6">
          <label className="label">
            <b>Email</b> &nbsp; &nbsp;&nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="email"
            value={data.email || ''}
            name="email"
            id="email"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Client Type</b> &nbsp;
          </label>
          <Select2
            name="typeClient.id"
            data={typeClientArray.map((group: any): DataSelect2 => {
              return { text: group.name, id: group.id };
            })}
            value={(data.typeClient && data.typeClient.id) || ''}
            options={{
              placeholder: 'Select option',
            }}
            onChange={props.onChange}
            style={{ width: '80%' }}
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-6">
          <label className="label">
            <b>Password</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="password"
            value={data.password || ''}
            name="password"
            onChange={props.onChange}
            required={isNew}
          />
          {isNew && <label>&nbsp;&nbsp;*</label>}
        </div>
        <br />
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Dashboard</b> &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
          </label>
          <Select2
            multiple
            name="accessListArray"
            id="accessListArray"
            data={accessListArray.map((group: any): DataSelect2 => {
              return { text: group.name, id: group.id };
            })}
            value={data.accessList}
            options={{
              placeholder: 'Select option',
            }}
            onSelect={props.onChangeMultiple}
            onUnselect={props.onChangeMultiple}
            style={{ width: '80%' }}
          />
        </div>
        <div className="col-4">
          <label className="label">
            <b>Main Dashboard</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={(data.accessList && (data.accessList[0])) || ''}
            name="dashboardOrder"
            onChange={props.onChange}
            readOnly
          />
        </div>
        <div className="col-2">
          <label className="label">&nbsp;</label>
          <button
            type="button"
            onClick={props.onInfo}
            className="btn btn-secondary"
            style={{ margin: '0px 0 0 5px', padding: '0 22px', height: '31px' }}
            disabled={!data.id}
          >
            Dashboard
          </button>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-4">
          <label className="label">
            <b>API Key</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.apikey || ''}
            name="apikey"
            readOnly
          />
        </div>
        <div className="col-2">
          <label className="label">&nbsp;</label>
          <button
            type="button"
            onClick={props.genApiKey}
            className="btn btn-secondary"
            style={{ margin: '0px 0 0 5px', padding: '0 22px', height: '31px' }}
          >
            Generate
          </button>
        </div>
        <div className="col-6">
          <label className="label">
            <b>Status</b> &nbsp;
          </label>
          <input
            className="inputNew"
            type="checkbox"
            name="active"
            checked={data.active || false}
            onChange={props.onChange}
          />
          &nbsp;&nbsp;
          <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
            Active
          </label>
          &nbsp;&nbsp;
          <input
            className="inputNew"
            type="checkbox"
            name="validated"
            checked={data.validated || false}
            onChange={props.onChange}
          />
          &nbsp;&nbsp;
          <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
            Validated
          </label>
        </div>
      </div>
      <br />
      <br />
      <br />
      <footer>
        <div className="text-right">
          <div>
            <label>
              <i>This field is required (*)</i>
            </label>
          </div>
        </div>
        <div>
          {loading && (
            <img className="loading-wdna" alt="loading" src="assets/img/loading-wdna.gif" />
          )}
          <button type="button" onClick={props.onReset} className="btn btn-primary">
            Reset
          </button>
          <button type="submit" className="btn btn-primary">
            Save
          </button>
        </div>
      </footer>
      <br />
      <div className="row">
        <ContainerModal
          fullScreenButton={false}
          show={modalShow}
          title="SELECT DASHBOARD"
          modalClass="selector-modal"
          onClose={props.onCloseModal}
          footerButtons={[
            {
              text: 'OK',
              className: 'btn btn-primary',
              onClick: props.onCloseModal,
            },
          ]}
        >
          <div>
            <label className="label">
              <b>Selected File</b>
            </label>
            <div className="input input-file">
              <span className="button">
                <input
                  type="file"
                  id={fileId}
                  name="file"
                  onChange={props.onChangeTwo}
                  required={!props.formValues.id}
                  accept=".json"
                  style={{ width: '75%' }}
                />
                <br />
                <label className="label">
                  <b>Browse</b>
                </label>
                <br />
              </span>
              <div className="cl-element btn-select2-addon">
                <input type="text" id={fileName} placeholder="Include some files" readOnly style={{ width: '55%' }} />
                &nbsp;&nbsp;
                <button
                  type="button"
                  style={{ right: 'unset' }}
                  className="btn btn-default"
                  onClick={props.onHandleUploadFile}
                >
                  Save
                </button>
                <div hidden={!props.formValues.isFile}>
                  <button
                    type="button"
                    style={{ right: '40px', top: '0px' }}
                    className="btn btn-default"
                    onClick={props.onHandleDeletedFile}
                  >
                    Delete
                  </button>
                </div>
              </div>
              <br />
              <label className="label">
                <b>Old File</b>
              </label>
              <div hidden={props.formValues.isFile}>
                <input
                  className="inputNew"
                  style={{ width: '55%' }}
                  type="text"
                  size={50}
                  value="No files in server"
                  readOnly
                />
              </div>
              <div hidden={!props.formValues.isFile} className="cl-element btn-select2-addon">
                <input
                  className="inputNew"
                  style={{ width: '55%' }}
                  type="text"
                  size={50}
                  value={`client_${props.formValues.data.id}.json` || ''}
                  readOnly
                />
                &nbsp;&nbsp;
                <button
                  type="button"
                  style={{ right: 'unset' }}
                  className="btn btn-default"
                  onClick={props.download}
                >
                  Download
                </button>
                <button
                  type="button"
                  style={{ right: '40px' }}
                  className="btn btn-default"
                  onClick={props.showFreeboard}
                >
                  Show
                </button>
              </div>
            </div>
          </div>
        </ContainerModal>
      </div>
    </fieldset>
  );
}

export default Form;
